/* eslint-disable no-unused-vars */
import { FormFieldType } from '@/constants/form/FormFieldType'
import { FormField, FormFieldType as FormFieldObjType } from './formField'
import { TextField } from './textField'
import { CheckboxField } from './checkboxField'
import { ContentField } from './contentField'
import { StarRatingField } from './starRatingField'
import { DateField } from './dateField'
import { DateTimeField } from './dateTimeField'
import { EmailAddressField } from './emailAddressField'
import { HeadingField } from './headingField'
import { NumberField } from './numberField'
import { RadioField } from './radioField'
import { SelectField } from './selectField'
import { SignatureField } from './signatureField'
import { TextAreaField } from './textAreaField'
import YesNoField from './yesNoField'
import { SelectBoxField } from './selectBoxField'

/**
 * Creates an instance of FormGroup.
 * @typedef {Object} FormFieldObjType
 * @property {FormFieldObjType[]} fields - An array of form fields within the group.
 *
 * @typedef {FormFieldObjType & FormFieldObjType} FormGroupExtendType
 */

/**
 * Represents a form group.
 * @class
 */
export default class FormGroup extends FormField {
  /**
   * Create a new FormGroup.
   * @param {FormGroupExtendType} params
   */
  constructor(params) {
    super(params)
    this.fields = mapFieldsToModel(params.fields)
  }
}

const mapFieldsToModel = (fields) => {
  const mappedFields = []

  if (!fields || fields.length === 0) return mappedFields

  for (const field of fields) {
    switch (field.fieldType) {
      case FormFieldType.Checkbox:
        mappedFields.push(new CheckboxField(field))
        break
      case FormFieldType.Content:
        mappedFields.push(new ContentField(field))
        break
      case FormFieldType.Date:
        mappedFields.push(new DateField(field))
        break
      case FormFieldType.DateTime:
        mappedFields.push(new DateTimeField(field))
        break
      case FormFieldType.Email:
        mappedFields.push(new EmailAddressField(field))
        break
      case FormFieldType.Heading:
        mappedFields.push(new HeadingField(field))
        break
      case FormFieldType.Number:
        mappedFields.push(new NumberField(field))
        break
      case FormFieldType.Radio:
        mappedFields.push(new RadioField(field))
        break
      case FormFieldType.Select:
        mappedFields.push(new SelectField(field))
        break
      case FormFieldType.SelectBox:
        mappedFields.push(new SelectBoxField(field))
        break
      case FormFieldType.Signature:
        mappedFields.push(new SignatureField(field))
        break
      case FormFieldType.StarRating:
        mappedFields.push(new StarRatingField(field))
        break
      case FormFieldType.Text:
        mappedFields.push(new TextField(field))
        break
      case FormFieldType.TextArea:
        mappedFields.push(new TextAreaField(field))
        break
      case FormFieldType.YesNo:
        mappedFields.push(new YesNoField(field))
        break
      default:
        mappedFields.push(new FormField(field))
        break
    }
  }

  return mappedFields
}
